import React from "react";
import { Link } from "react-router-dom";

import trustedVideo from "../assets/trusted-advisors.mp4";
import { ArrowIcon } from "./Icons";

// Short facts pulled from the copy on this page and the rest of the site.
const FACTS = [
  { value: "10+", label: "Years of industry experience" },
  { value: "3", label: "Areas we advise on: lending, insurance and business finance" },
  { value: "NZ-wide", label: "Online, by phone, or in person in Flat Bush" },
];

function TrustedAdvisorsBanner() {
  return (
    <section className="trust-section">
      {/* Background video - decorative, so hidden from screen readers */}
      <video
        className="trust-video"
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      >
        <source src={trustedVideo} type="video/mp4" />
      </video>

      <div className="trust-overlay" />

      <div className="trust-inner">
        <div className="trust-copy">
          <span className="trust-kicker">Why Expert Finance</span>
          <h2 className="trust-title">
            We&apos;ve been doing this for over a decade.
          </h2>

          <p className="trust-text">
            We work with individuals and families on mortgages, refinancing
            and longer-term planning. After this long, there aren’t many
            situations we haven’t seen, including the complicated ones.
          </p>
          <p className="trust-text">
            Some clients come to us for their first home. Others are
            refinancing, or want a second look at their current loan. Either
            way, we start with your numbers and work from there.
          </p>

          <Link to="/about/team" className="pill-btn pill-btn-ghost">
            Meet the team
            <ArrowIcon />
          </Link>
        </div>

        <ul className="trust-facts">
          {FACTS.map(({ value, label }) => (
            <li key={value} className="trust-fact">
              <span className="trust-fact-value">{value}</span>
              <span className="trust-fact-label">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TrustedAdvisorsBanner;
